var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgChevronRightLight = function SvgChevronRightLight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 7 12"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M.816 11.62a.82.82 0 0 0 .569-.219l5.334-4.907c.185-.181.281-.368.281-.6a.76.76 0 0 0-.281-.595L1.385.386a.82.82 0 0 0-.57-.22C.358.166 0 .502 0 .928c0 .207.096.407.247.555L5.053 5.9.247 10.303A.77.77 0 0 0 0 10.86c0 .426.357.762.816.762"
  })));
};
export default SvgChevronRightLight;